import { render } from "./zMessage.vue?vue&type=template&id=327ee104"
import script from "./zMessage.vue?vue&type=script&lang=js"
export * from "./zMessage.vue?vue&type=script&lang=js"

import "./zMessage.vue?vue&type=style&index=0&id=327ee104&lang=css"

import exportComponent from "C:\\開発\\PSAP\\おくやみシステム\\OJ0000P_Vue\\OJ0000P\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__